/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import type { ReadAuthMethodApiResponse } from 'lib-shared-types-api';

/**
 * Transforms the auth method response.
 *
 * @param response The response from the endpoint.
 */
export function transformReadAuthMethodResponse(
  response: any,
): ReadAuthMethodApiResponse {
  const magicLinkAuthMethod = response.data.auth_methods.find(
    ({ type }) => type === 'dixa_magic_link',
  );
  const oktaClientAuthMethod = response.data.auth_methods.find(
    ({ type }) => type === 'okta_openid_connect',
  );

  return {
    data: {
      auth_method: oktaClientAuthMethod ?? magicLinkAuthMethod,
    },
    meta: {},
  };
}
